package pl.decks.chartjs.value

import pl.decks.chartjs.jsConstructors.jso

sealed class ClipValue {
    object NoClip : ClipValue()
    data class Uniform(val padding: Int) : ClipValue()
    data class Sides(
        val left: Int,
        val right: Int,
        val top: Int,
        val bottom: Int,
    ) : ClipValue()

    internal fun toChartJs() : dynamic = when (this) {
        is NoClip -> false.asDynamic()
        is Uniform -> padding.asDynamic()
        is Sides -> jso {
            this.left = this@ClipValue.left
            this.right = this@ClipValue.right
            this.top = this@ClipValue.top
            this.bottom = this@ClipValue.bottom
        }
    }
}
